import { useQuery } from "@tanstack/react-query";
import { HotelSummaryRequest, HotelSummaryResource } from "../types/hotel";
import { hotelSectionService } from "./hotelSectionService";

export const useHotelSummary = (sectionId: number, request: HotelSummaryRequest) => {
	const query = useQuery<HotelSummaryResource[]>({
		queryKey: hotelSectionService.hotelSummaryKey(sectionId, request),
		queryFn: () => hotelSectionService.getHotelSummary(sectionId, request),
	});

	return {
		data: query.data,
		isLoading: query.isLoading,
	};
};
